import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Route, Router } from '@angular/router';
import { CheckVersionPageModule } from 'src/app/pages/roster/check-version/check-version.module';
import { NavigationHistoryStack } from './navigation-history-stack';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  constructor(
    private router: Router,
    private location: Location,
    private navigationStack: NavigationHistoryStack
  ) {}

  async nav(target) {
    await this.router.navigate(target);
  }

  async back() {
    const canNavBack = !this.navigationStack.isEmpty();
    if (canNavBack) {
      this.location.back();
    } else {
      await this.router.navigateByUrl('/');
    }
  }

  async navigateToCheckVersion() {
    const route = CheckVersionPageModule.route;
    await this.navigateByPath(route);
  }

  private async navigateByPath(route: Route) {
    const url = this.getUrlFromRoute(route);
    await this.nav([url]);
  }

  private getUrlFromRoute(route: Route): string {
    const url = `/${route.path}`;
    return url;
  }
}
